import type { Identifier } from "ra-core";
import { createContext, useContext } from "react";

import type { Sale } from "@/components/atomic-crm/types";

import type { MetricsTarget, PieceFormValues } from "./forms";
import type { ContentItem, ContentMetric, MarketingData } from "./types";

export interface MarketingActions {
  data: MarketingData;
  sales: Sale[];
  /** Opens the piece sheet (?pieza=ID). */
  openPiece: (id: Identifier) => void;
  /** Opens the piece form, empty or prefilled (a calendar day, a plan…). */
  newPiece: (prefill?: Partial<PieceFormValues>) => void;
  editPiece: (piece: ContentItem) => void;
  /** Opens "Registrar métricas" for a piece / channel, or edits a row. */
  recordMetrics: (target?: MetricsTarget, row?: ContentMetric) => void;
}

export const MarketingContext = createContext<MarketingActions | null>(null);

export const useMarketing = (): MarketingActions => {
  const value = useContext(MarketingContext);
  if (!value) throw new Error("useMarketing outside <MarketingPage>");
  return value;
};
